import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { isOnIndustryStepAndCredentialVerifiedNewUser } from '../google-authentication/google-prompt/googlePromptTracking';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getIsOAuthExistingUser, getIsVerifiedByGoogleCredential } from '../store/app/selectors';
import { getPreviousStep } from '../store/flow/selectors';
import { devices } from 'signup-constants/styles/viewports.styles';
import { Step } from 'signup-constants/Step';
import { getStepConfig } from '../views/getStepConfig';
import { NameSubtitle } from './NameSubtitle';
import { jsx as _jsx } from "react/jsx-runtime";
export const PretitlePlaceHolder = styled.div.withConfig({
  displayName: "GreetingsPretitle__PretitlePlaceHolder",
  componentId: "lij7l5-0"
})(["height:43.5px;", ""], props => props.$showMessagingAboveContent && `
    height: 0;

    @media ${devices.tablet} {
      height: 43.5px;
    }

  `);
export const GreetingsPretitle = ({
  hasPreTitle
}) => {
  const previousStep = useSelector(getPreviousStep);
  const {
    currentStep
  } = useCurrentStep();
  const isGoogleCredentialAuthentication = useSelector(getIsVerifiedByGoogleCredential);
  const isExistingOAuthUser = useSelector(getIsOAuthExistingUser);
  const hasSelectedOAuthSignup = useSelector(isOAuthSignup);
  const hasJustSubmittedName = previousStep === Step.Name || previousStep === Step.LandingPage && hasSelectedOAuthSignup;
  const stepConfig = getStepConfig(currentStep);
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  if (isOnIndustryStepAndCredentialVerifiedNewUser(currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser)) {
    return /*#__PURE__*/_jsx(NameSubtitle, {
      translation: "views.nice-to-meet-you"
    });
  }
  if (hasJustSubmittedName) {
    return /*#__PURE__*/_jsx(NameSubtitle, {
      translation: "views.nice-to-meet-you"
    });
  }
  if (previousStep === Step.ExistingAccounts) {
    return /*#__PURE__*/_jsx(NameSubtitle, {
      translation: "views.hi"
    });
  }
  return !hasPreTitle ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(PretitlePlaceHolder, {
    $showMessagingAboveContent: showMessagingAboveContent
  }) : null;
};